import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { 
  Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Paper, TablePagination 
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import api from '../../service/axios/api';
import Loading from '../../components/loading/Loading';

const optionsFilter = [
    { label: 'Tipo', value: 'type' },
    { label: 'Complemento', value: 'complement' },
    { label: 'Valor', value: 'amount' },
    { label: 'Data', value: 'transaction_date' },
];

const customStyles = {
    control: provided => ({
        ...provided,
        width: 150,
        height: 40,
        borderRadius: 10,
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
};

const useStyles = makeStyles({
    input: {
        backgroundColor: '#fff',
        marginTop: 0,
    },
});

export default function StatementQuery() {
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterType, setFilterType] = useState({ label: 'Tipo', value: 'type' });
    const searchRef = useRef(null);
    const [page, setPage] = useState(0);    // Página atual (começa em 0)
    const [total, setTotal] = useState(0);  // Total de registros no banco
    const [itens, setItens] = useState(10); // Quantidade de itens por página

    const searchData = () => {
        const filters = [];
     
        // Filtro do campo de busca livre
        if (searchRef.current?.value && filterType.value) {
            filters.push({
                filter: filterType.value,
                filterValue: searchRef.current.value,
            });
        }

        setLoading(true);
        api.statementQuery
            .getAll(
                page + 1, 
                itens, 
                filters
            )
            .then(res => {
                setTotal(res.total);
                const docsFormatados = res.docs.map(statement => ({
                    ...statement,
                    transaction_date: new Date(statement.transaction_date).toLocaleDateString('pt-BR', {timeZone: 'UTC'})
                }));
                setData(docsFormatados);
                console.log(res.docs);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
            });
    };

    useEffect(() => {
        searchData();
    }, [page, itens]);

    return (
        <>
            <Loading open={loading} msg="Buscando extratos..." />

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <h1>Extrato Bancário</h1>
                </Grid>

                {/* Filtro por tipo */}


                {/* Busca livre */}
                <Grid item xs={12} sm={5}>
                    <Grid container spacing={1} style={{ justifyContent: 'end' }}>
                        <Grid item xs={12} sm={4}>
                            <Select
                                styles={customStyles}
                                onChange={setFilterType}
                                placeholder="Campo"
                                isSearchable={false}
                                options={optionsFilter}
                                menuPortalTarget={document.body}
                            />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <TextField
                                inputRef={searchRef}
                                color="secondary"
                                fullWidth
                                size="small"
                                variant="outlined"
                                InputProps={{ className: classes.input }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button type="button" onClick={searchData} variant="contained">
                                Buscar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>

                {/* Tabela */}
                {/* Tabela */}
<Grid item xs={12}>
    {data.length === 0 ? (
        <p>Nenhum extrato encontrado.</p>
    ) : (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell>Data</TableCell>
                        <TableCell>Descrição</TableCell>
                        <TableCell>Tipo</TableCell>
                        <TableCell>Valor</TableCell>
                        <TableCell>Complemento</TableCell>
                        <TableCell>Nome Banco</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map(statement => (
                        <TableRow key={statement.id}>
                            <TableCell>{statement.transaction_date}</TableCell>
                            <TableCell>{statement.description}</TableCell>
                            <TableCell>{statement.type}</TableCell>
                            <TableCell>{statement.amount}</TableCell>
                            <TableCell>{statement.complement}</TableCell>
                            <TableCell>SANTANDER</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

                {/* LÓGICA DE PAGINAÇÃO ABAIXO DA TABELA */}
           <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={total}
                rowsPerPage={itens}
                page={page}
                // Troque de onPageChange para onChangePage
                onChangePage={(event, newPage) => {
                    setPage(newPage);
                }}
                // Troque de onRowsPerPageChange para onChangeRowsPerPage
                onChangeRowsPerPage={(event) => {
                    setItens(parseInt(event.target.value, 10));
                    setPage(0);
                }}
                labelRowsPerPage="Linhas por página:"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            />
                        </TableContainer>
                    )}
                </Grid>
            </Grid>

        </>
    );
}
